import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const probateValuationsApi = createApi({
  reducerPath: "probateValuationsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProbateValuation"],
  endpoints: (build) => ({
    getAllValuations: build.query({
      query: () => ({ url: "/probate/valuations", method: "GET" }),
      providesTags: ["ProbateValuation"],
    }),
    upsertValuation: build.mutation({
      query: (data) => ({ url: "/probate/valuations", method: "POST", body: data }),
      invalidatesTags: ["ProbateValuation"],
    }),
    deleteValuation: build.mutation({
      query: (id) => ({ url: `/probate/valuations/${id}`, method: "DELETE" }),
      invalidatesTags: ["ProbateValuation"],
    }),
  }),
});

export const {
  useGetAllValuationsQuery,
  useUpsertValuationMutation,
  useDeleteValuationMutation,
} = probateValuationsApi;
